import { Cell, Grid, HeadingSection, InfoLabel, Text } from 'bold-ui'
import { booleanToSimNaoTitleCase } from 'components/form'
import { Cbo, Escolaridade, InformacoesSociodemograficas } from 'graphql/types.generated'
import React from 'react'
import { isObjectDeepEmpty } from 'util/object'
import {
  criancas0a9anosComQuemFicaRecord,
  deficienciaRecord,
  povoComunidadeTradicionalRecord,
  situacaoMercadoTrabalhoRecord,
} from 'view/cidadao/createfci/model-cidadaoFci'
import { formatSimNaoJoinRespostas } from 'view/cidadao/util-cidadao'

interface CidadaoFciInformacoesSociodemograficasSectionProps {
  informacoesSociodemograficas: InformacoesSociodemograficas
  escolaridade: Escolaridade
  cbo: Cbo
}

export const CidadaoFciInformacoesSociodemograficasSection = (
  props: CidadaoFciInformacoesSociodemograficasSectionProps
) => {
  const { informacoesSociodemograficas, escolaridade, cbo } = props

  const { id, __typename, ...rest } = informacoesSociodemograficas ?? {}
  const isInformacoesSociodemograficasVazio = isObjectDeepEmpty(rest)

  if (isInformacoesSociodemograficasVazio)
    return (
      <HeadingSection level={2} title='Informações sociodemográficas'>
        <Text fontStyle='italic'>Sem informações registradas</Text>
      </HeadingSection>
    )

  return (
    <HeadingSection level={2} title='Informações sociodemográficas'>
      <Grid wrap>
        <Cell size={4}>
          <InfoLabel title='Escolaridade'>{escolaridade?.nome}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Frequenta escola ou creche'>
            {booleanToSimNaoTitleCase(informacoesSociodemograficas?.frequentaEscolaOuCreche)}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Com quem fica a criança (Menores de 9 anos)'>
            {informacoesSociodemograficas?.criancas0a9anosComQuemFica
              ?.map((item) => criancas0a9anosComQuemFicaRecord[item])
              .sort()
              .join(', ')}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Situação no mercado de trabalho'>
            {situacaoMercadoTrabalhoRecord[informacoesSociodemograficas?.situacaoMercadoTrabalho]}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Ocupação'>{cbo?.nome.titleCase()}</InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Plano de saúde privado'>
            {booleanToSimNaoTitleCase(informacoesSociodemograficas?.possuiPlanoSaudePrivado)}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Frequenta cuidador tradicional'>
            {booleanToSimNaoTitleCase(informacoesSociodemograficas?.frequentaCuidadorTradicional)}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Participa de grupo comunitário'>
            {booleanToSimNaoTitleCase(informacoesSociodemograficas?.participaAlgumGrupoComunitario)}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Membro de Povo ou Comunidade Tradicional ou Campo, Floresta e Água'>
            {formatSimNaoJoinRespostas(
              informacoesSociodemograficas?.isMembroComunidadeTradicional,
              povoComunidadeTradicionalRecord[informacoesSociodemograficas?.povoComunidadeTradicional]
            )}
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Possui alguma deficiência'>
            {formatSimNaoJoinRespostas(
              informacoesSociodemograficas?.possuiDeficiencia,
              informacoesSociodemograficas?.deficiencias.map((item) => deficienciaRecord[item])
            )}
          </InfoLabel>
        </Cell>
      </Grid>
    </HeadingSection>
  )
}
